/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Size_RunInputs */

const en_reference_dataset_size_run = /** @type {(inputs: Reference_Dataset_Size_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size runs`)
};

/**
* | output |
* | --- |
* | "Size runs" |
*
* @param {Reference_Dataset_Size_RunInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_size_run = /** @type {((inputs?: Reference_Dataset_Size_RunInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Size_RunInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_size_run(inputs)
});